import { useEffect } from "react";
import { useState } from "react";
import styled from "styled-components";

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 10000001;
  width: 100vw;
  height: 100vh;

  & strong {
    color: #e74c3c;
  }

  .modal-section {
    position: fixed;
    top: 10vh;
    left: 25vw;
    width: 50vw;
    height: 80vh;
    background-color: white;
    overflow: auto;
    border: none;
    display: flex;
    flex-direction: column;
    @media screen and (max-width: 991px) {
      top: 10vh;
      left: 15vw;
      width: 70vw;
      height: 80vh;
    }
    @media screen and (max-width: 767px) {
      left: 10vw;
      width: 80vw;
    }
  }

  .header {
    display: flex;
    padding: 10px 10px;
    & img {
      margin-left: auto;
      width: 35px;
      cursor: pointer;
    }
  }
  .title {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
    & h4 {
      color: #3bb77e;
    }
  }

  .modal-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    border: none;
    margin: 0 auto;
    overflow-y: auto;
    padding: 0px 36px 36px 36px !important;
    & > span {
      color: black;
    }
  }

  .inputWrapper {
    width: 100%;
    margin-bottom: 20px;
    & h6 {
      margin-bottom: 10px;
    }
    & input {
      height: 38px;
      margin-bottom: 10px;
      ::placeholder {
        font-size: 14px;
        color: #6c757da5;
      }
      :focus {
        border-color: #3bb77e !important;
        box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;
      }
    }
    .col {
      display: flex;
      flex-direction: column;
      width: 50%;
      & input {
        width: 100%;
        padding-right: 0;
      }
    }
    @media screen and (max-width: 575px) {
      .row {
        display: flex;
        flex-direction: column;
        .col {
          width: 100%;
        }
      }
    }
  }

  & textarea {
    min-height: 150px;
    ::placeholder {
      font-size: 14px;
      color: #6c757da5;
    }
    :focus {
      border-color: #3bb77e !important;
      box-shadow: 0 0 0 0.25rem rgba(59, 183, 126, 0.25) !important;
    }
  }
  .btnWrapper {
    width: 100%;
    & button {
      width: 100%;
    }
  }

  .checkboxWrapper {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 10px;
    margin-bottom: 20px;
    @media screen and (max-width: 767px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  .designCheck {
    margin-bottom: 30px;
    display: flex;
    flex-wrap: wrap;
  }
`;

const CheckBox = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${(props) => (props.design ? "5px" : "0")};
  word-break: keep-all;
`;

const CheckBoxLabel = styled.label`
  width: ${(props) => (props.design ? "fit-content" : "100%")};
  font-size: 1rem;
  padding: ${(props) => (props.design ? "10px 20px" : "10px 10px")};
  overflow: hidden;
  border: 2px solid #ececec;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.checked ? "#d6f2e5" : "#fff")};
  color: #4e4e4e;
  border-color: ${(props) => (props.checked ? "#3bb77e" : "#ececec")};
  border-radius: 10px;
  position: relative;
  cursor: pointer;

  & img {
    margin: 0 auto;
  }

  .label_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #4e4e4e;
    font-size: 14px;
    text-align: center;

    & i {
      padding-top: 1px;
      :hover {
        color: #3bb77e;
      }
    }
  }
`;

const FileWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 20px;
  row-gap: 10px;
  & input {
    padding: 6px 5px;
  }
  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const DesignInquiryModal = ({
  onClickInquiry,
  submitInquiry,
  openInquiryModal,
  onChangeInquiry,
  inquiryInputs,
}) => {
  globalThis.onkeydown = (e) => {
    if (e.code === "Escape") return onClickInquiry();
  };

  const planArr = [
    { value: "베이직 A" },
    { value: "베이직 B" },
    { value: "스탠다드" },
    { value: "브랜드" },
    { value: "상담 후 결정" },
  ];

  const designArr = [
    { value: "이미 사용중인 패키지 디자인 Ai 파일이 있으나 수정이 필요해요" },
    { value: "디자인을 가지고 있지 않아요" },
    { value: "패키지 디자인은 없고 로고 Ai 파일만 가지고 있어요." },
    { value: "디자인 사진은 있으나 Ai 파일은 가지고 있지 않아요" },
    { value: "기존 사용했던 디자인 Ai 파일은 있으나 새로 만들고 싶어요." },
    { value: "기타 (의견은 문의사항에 남겨주세요)" },
  ];

  return (
    <>
      <ModalWrapper>
        <div className="modal-section">
          <div className="header">
            <img
              src="/assets/imgs/page/common/modal_close_icon.png"
              alt="modal_close_icon"
              onClick={onClickInquiry}
            />
          </div>
          <div className="title">
            <h4>정보를 입력해주세요</h4>
          </div>
          <div className="modal-content">
            <div className="inputWrapper">
              <div className="row">
                <div className="col">
                  <h6>문의자 명</h6>
                  <input type="text" onChange={onChangeInquiry("name")} />
                </div>
                <div className="col">
                  <h6>문의자 연락처</h6>
                  <input type="text" onChange={onChangeInquiry("tel")} />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6>업체명</h6>
                  <input type="text" onChange={onChangeInquiry("company")} />
                </div>
                <div className="col">
                  <h6>수량</h6>
                  <input type="text" onChange={onChangeInquiry("cnt")} />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6>포장상품 정보</h6>
                  <input
                    type="text"
                    onChange={onChangeInquiry("usages")}
                    placeholder="ex) 농산물 달기, 의류 등"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6>원하는 상품</h6>
                  <input
                    type="text"
                    onChange={onChangeInquiry("option_1")}
                    placeholder="ex) 노테이프 박스, 골판지 박스, 바이오 비닐봉투"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6>원하는 플랜</h6>
                  <div className="checkboxWrapper">
                    {planArr.map((el, i) => (
                      <CheckBox className="custome-checkbox" key={i}>
                        <input
                          type="checkbox"
                          id={`${el.value}`}
                          name="planOptions"
                          className="form-check-input"
                          value={`${el.value}`}
                          onChange={onChangeInquiry("option_2")}
                        />
                        <CheckBoxLabel
                          htmlFor={`${el.value}`}
                          value={`${el.value}`}
                          checked={inquiryInputs["option_2"] === el.value}
                          style={{
                            textTransform: "capitalize",
                          }}
                        >
                          <span className="label_title">{el.value}</span>
                        </CheckBoxLabel>
                      </CheckBox>
                    ))}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6>가지고 계신 디자인이 있으신가요?</h6>
                  <div className="designCheck">
                    {designArr.map((el, i) => (
                      <CheckBox
                        className="custome-checkbox"
                        key={i}
                        design={true}
                      >
                        <input
                          type="checkbox"
                          id={`${el.value}`}
                          name="designOptions"
                          className="form-check-input"
                          value={`${el.value}`}
                          onChange={onChangeInquiry("option_3")}
                        />
                        <CheckBoxLabel
                          htmlFor={`${el.value}`}
                          value={`${el.value}`}
                          checked={inquiryInputs["option_3"] === el.value}
                          style={{
                            textTransform: "capitalize",
                          }}
                          design={true}
                        >
                          <span className="label_title">{el.value}</span>
                        </CheckBoxLabel>
                      </CheckBox>
                    ))}
                  </div>
                </div>
              </div>
              <div className="row mb-20">
                <div className="col">
                  <h6>문의 내용</h6>
                  <textarea
                    type="text"
                    onChange={onChangeInquiry("content")}
                    placeholder="ex) 언제까지 필요하신가요, 어떤 디자인서비스가 필요하신가요, 추가적인 문의사항을 남겨주세요"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <h6>첨부 파일</h6>
                  <FileWrapper>
                    <input
                      type="file"
                      className="form-control"
                      onChange={onChangeInquiry("file1")}
                    />
                    <input
                      type="file"
                      className="form-control"
                      onChange={onChangeInquiry("file2")}
                    />
                    <input
                      type="file"
                      className="form-control"
                      onChange={onChangeInquiry("file3")}
                    />
                  </FileWrapper>
                </div>
              </div>
            </div>
            <div className="btnWrapper">
              <button className="btn" onClick={submitInquiry}>
                문의하기
              </button>
            </div>
          </div>
        </div>
      </ModalWrapper>
    </>
  );
};
export default DesignInquiryModal;
